import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c79d048"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sign" }, null, -1))
const _hoisted_2 = { class: "measurement-form-parts" }
const _hoisted_3 = { class: "measurement-form-part" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-building" }, null, -1))
const _hoisted_5 = { class: "measurement-form-part" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-cubes" }, null, -1))
const _hoisted_7 = { class: "measurement-form-part" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-align-center" }, null, -1))
const _hoisted_9 = { class: "measurement-form-part" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-globe" }, null, -1))
const _hoisted_11 = { class: "measurement-form-part" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-alt" }, null, -1))
const _hoisted_13 = { class: "measurement-form-part" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-alt" }, null, -1))
const _hoisted_15 = { class: "measurement-form-part" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-suitcase" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "measurement-form-part" }, null, -1))
const _hoisted_18 = { class: "measurement-form-part" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-eye" }, null, -1))
const _hoisted_20 = { class: "measurement-form-part" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-bullseye-pointer" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-browser" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "py-m"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Zrušit ")

import {
	NInput,
	NButton,
	NDynamicInput,
	NResult,
	NSelect,
	NAlert,
	NForm,
	NFormItem,
	NInputNumber,
	NInputGroup,
	NDatePicker,
	NInputGroupLabel,
	FormRules,
	FormValidationError,
	SelectOption,
	useMessage,
} from 'naive-ui';
import {
	reactive,
	ref,
	withDefaults,
	computed,
	onBeforeMount,
	h,
	VNodeChild,
} from 'vue';
import { API } from '@/api';
import { useRouter } from 'vue-router';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import { useStore } from 'vuex';
import { SelectMixedOption } from 'naive-ui/lib/select/src/interface';
import { DateTime, Settings } from 'luxon';

interface Errors {
	name?: string;
	start_date?: string;
	end_date?: string;
	url?: string;
	type_id?: string;
	web_id?: string;
	impressions_target?: string;
	clicks_target?: string;
	client?: string;
	campaign?: string;
	sales_person_id?: string;
	target_url?: string;
	message?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isEdit: { type: Boolean, default: false },
    editData: { default: undefined }
  },
  emits: ['editSuccess', 'editClose'],
  setup(__props: any, { emit }) {

const props = __props as { isEdit: boolean, editData: Measurement }

Settings.defaultLocale = 'cs';



const pending = ref<boolean>(false);
const formRef = ref();
const successMessage = ref<string | undefined>();
const { push: pushRoute } = useRouter();
const message = useMessage();
const { dispatch, getters } = useStore();
const listRedirect = () => pushRoute('/mereni/prehled');
const detailRedirect = (id: string) => pushRoute(`/mereni/detail/${id}`);
const targetStep = ref<number>(1000);
const lists = computed<ListsData>(() => getters['lists/allData']);

const errors = reactive<Errors>({
	name: undefined,
	start_date: undefined,
	end_date: undefined,
	type_id: undefined,
	web_id: undefined,
	impressions_target: undefined,
	clicks_target: undefined,
	client: undefined,
	campaign: undefined,
	sales_person_id: undefined,
	target_url: undefined,
	message: undefined,
});
const today = DateTime.local();

const formModel = ref<Measurement.Form>({
	name: null,
	start_date: today.startOf('day').toMillis(),
	end_date: today.plus({ year: 1 }).endOf('day').toMillis(),
	url: null,
	web_id: null,
	type_id: null,
	impressions_target: 0,
	clicks_target: 0,
	client: null,
	campaign: null,
	sales_person_id: null,
	target_url: [],
});
const startDateRef = ref();
const endDateRef = ref();

const regUrl = new RegExp(
	/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
	'i'
);

const measurementTypeOptions = computed<SelectMixedOption[]>(() =>
	lists.value.measurementTypes.map(
		(item: List): SelectMixedOption => ({ label: item.name, value: item.id })
	)
);
const measurementWebOptions = computed<SelectMixedOption[]>(() =>
	lists.value.webs.map((item: List): SelectMixedOption => ({ label: item.name, value: item.id }))
);
const clientsOptions = computed<SelectMixedOption[]>(() =>
	lists.value.clients.map(
		(item: List): SelectMixedOption => ({ label: item.name, value: item.name })
	)
);
const campaignsOptions = computed<SelectMixedOption[]>(() =>
	lists.value.campaigns.map(
		(item: List): SelectMixedOption => ({ label: item.name, value: item.name })
	)
);
const salesPersonsOptions = computed<SelectMixedOption[]>(() => {
	const tempSalesPersons = lists.value.salesPersons.filter((item) => !item.disabled);

	if (props.isEdit) {
		const assignedUser = lists.value.salesPersons.find(
			(item) => item.id === formModel.value.sales_person_id
		);
		const userAlreadyExists = tempSalesPersons.find(
			(item) => item.id === formModel.value.sales_person_id
		);

		if (assignedUser && !userAlreadyExists) {
			tempSalesPersons.push(assignedUser);
		}
	}
	return tempSalesPersons.map(
		(item: List): SelectMixedOption => ({
			label: item.name,
			value: item.id,
			disabled: item.disabled,
		})
	);
});

const renderLabel = (option: SelectOption): VNodeChild => {
	if (option.style) {
		return [
			option.label as string,
			h('i', {
				class: 'fal fa-ban ml-s',
			}),
		];
	}
	return option.label as string;
};

const handleStartDateInput = () => {
	endDateRef.value.validate({ trigger: 'start-date-input' });
};
const handleEndDateInput = () => {
	startDateRef.value.validate({ trigger: 'end-date-input' });
};

const rules = ref<FormRules>({
	name: [
		{
			required: true,
			message: 'Název je povinný',
			trigger: ['input', 'blur'],
		},
	],
	start_date: [
		{
			validator: (rule, value) => {
				if (DateTime.fromMillis(value) > DateTime.fromMillis(formModel.value.end_date)) {
					return new Error(
						'Začátek měření musí být před koncem měření nebo stejný jako konec měření'
					);
				}
				return true;
			},
			trigger: ['input', 'end-date-input'],
		},
	],
	end_date: [
		{
			validator: (rule, value) => {
				if (DateTime.fromMillis(value) < DateTime.fromMillis(formModel.value.start_date)) {
					return new Error(
						'Konec měření musí být po začátku měření nebo stejný jako začátek měření'
					);
				}
				return true;
			},
			trigger: ['input', 'start-date-input'],
		},
	],
	web_id: [
		{
			required: true,
			message: 'Web je povinný',
			trigger: ['input', 'blur'],
		},
	],
	type_id: [
		{
			required: true,
			message: 'Typ článku je povinný',
			trigger: ['input', 'blur'],
		},
	],
	url: [
		{
			validator: (rule, value) => {
				if (value === null || value === '') {
					return true;
				}
				if (!value.match(/^https?:\/\/.+/)) {
					return new Error('URL musí začínat http:// nebo https://');
				}
				if (!value.match(regUrl)) {
					return new Error('Musí být platná URL. např.: https://domain.tld');
				}

				return true;
			},
			trigger: ['input', 'blur'],
		},
	],
	impressions_target: [],
	clicks_target: [],
	client: [
		{
			required: true,
			message: 'Klient je povinný',
			trigger: ['input', 'blur'],
		},
	],
	campaign: [
		{
			required: true,
			message: 'Kampaň je povinná',
			trigger: ['input', 'blur'],
		},
	],
	sales_person_id: [
		{
			required: true,
			message: 'Obchodník je povinný',
			trigger: ['input', 'blur'],
		},
	],
	target_url: [
		{
			validator: (rule, value) => {
				let targetUrlError: string | undefined;
				for (let i = 0; i < value.length; i += 1) {
					const item = value[i];

					if (typeof item === 'undefined' || item === null) {
						break;
					}
					if (!item.match(/^https?:\/\/.+/)) {
						targetUrlError = `#${i + 1} - URL musí začínat http:// nebo https://`;
						break;
					}
					if (!item.match(regUrl)) {
						targetUrlError = `#${i + 1} - Musí být platná URL. např.: https://domain.tld`;
						break;
					}
				}
				if (targetUrlError) {
					return new Error(targetUrlError);
				}

				return true;
			},
			trigger: ['input', 'blur'],
		},
	],
});

const stornoEdit = () => emit('editClose');

const delayedFetchLists = (cb: () => void, timeout: number): Promise<void> => {
	return new Promise((resolve) => {
		setTimeout(() => {
			cb();
			resolve();
		}, timeout);
	});
};

const submitForm = async () => {
	if (props.isEdit && props.editData.deleted_at) {
		return;
	}
	successMessage.value = undefined;
	errors.name = undefined;
	errors.start_date = undefined;
	errors.end_date = undefined;
	errors.url = undefined;
	errors.type_id = undefined;
	errors.impressions_target = undefined;
	errors.clicks_target = undefined;
	errors.client = undefined;
	errors.campaign = undefined;
	errors.sales_person_id = undefined;
	errors.target_url = undefined;
	errors.message = undefined;
	if (formRef.value !== null && typeof formRef.value.validate === 'function') {
		await formRef.value.validate(async (validationErrors: FormValidationError) => {
			if (!validationErrors) {
				pending.value = true;
				try {
					const formData: Measurement.InputForm = {
						...formModel.value,
						start_date: DateTime.fromMillis(formModel.value.start_date).startOf('day').toISO(),
						end_date: DateTime.fromMillis(formModel.value.end_date).endOf('day').toISO(),
					};

					let result: Measurement.Api.Edit.Response | Measurement.Api.Create.Response;

					if (props.isEdit) {
						result = await API.measurement.updateMeasurement(props.editData.id, formData);

						await dispatch('measurement/fetchData', true);
						await delayedFetchLists(() => dispatch('lists/fetchData', true), 1000);

						emit('editSuccess');

						message.success('Měření bylo úspěšně změněno.');
						pending.value = false;
					} else {
						result = await API.measurement.createMeasurement(formData);

						await dispatch('measurement/fetchData', true);
						await delayedFetchLists(() => dispatch('lists/fetchData', true), 1000);

						message.success('Měření bylo úspěšně vytvořeno.');
						pending.value = false;

						const { id } = result?.payload || {};

						if (typeof id !== 'string') {
							await listRedirect();
						} else {
							await detailRedirect(result?.payload?.id);
						}
					}
				} catch (error) {
					pending.value = false;
					const catchError: AjaxResponseDto = error as AjaxResponseDto;
					const { message: errorMessage, fields } = catchError?.payload as MessageResponseDto;

					if (typeof fields === 'object' && fields !== null && Object.keys(fields).length > 0) {
						Object.keys(fields).forEach((key) => {
							if (
								key === 'name' ||
								key === 'url' ||
								key === 'web_id' ||
								key === 'start_date' ||
								key === 'end_date' ||
								key === 'type_id' ||
								key === 'impressions_target' ||
								key === 'clicks_target' ||
								key === 'client' ||
								key === 'campaign' ||
								key === 'sales_person_id' ||
								key === 'target_url'
							) {
								errors[key] = fields[key];
							}
						});
					} else {
						errors.message =
							errorMessage ||
							(props.isEdit
								? 'Neznámá chyba při editaci záznamu'
								: 'Neznámá chyba při vytváření záznamu');
					}
				}
			}
		});
	}
};
onBeforeMount(async () => {
	if (props.isEdit && typeof props.editData !== 'undefined') {
		formModel.value = {
			name: props.editData.name || null,
			start_date: (typeof props.editData.start_date !== 'undefined' &&
			props.editData.start_date !== null
				? DateTime.fromISO(props.editData.start_date)
				: today
			)
				.startOf('day')
				.toMillis(),
			end_date: (typeof props.editData.end_date !== 'undefined' && props.editData.end_date !== null
				? DateTime.fromISO(props.editData.end_date)
				: today
			)
				.endOf('day')
				.toMillis(),
			url: props.editData.url || null,
			web_id: props.editData.web_id || null,
			type_id: props.editData.type_id || null,
			impressions_target: props.editData.impressions_target || 0,
			clicks_target: props.editData.clicks_target || 0,
			client: props.editData.client_name || null,
			campaign: props.editData.campaign_name || null,
			sales_person_id: props.editData.sales_person_id || null,
			target_url: props.editData.target_url || [],
		};
	}
});

return (_ctx: any,_cache: any) => {
  return (successMessage.value)
    ? (_openBlock(), _createBlock(_unref(NResult), {
        key: 0,
        status: "success",
        class: "pt-m",
        description: typeof successMessage.value === 'string' ? successMessage.value : ''
      }, null, 8, ["description"]))
    : (_openBlock(), _createBlock(_unref(NForm), {
        key: 1,
        ref_key: "formRef",
        ref: formRef,
        model: formModel.value,
        rules: rules.value,
        style: {"width":"100%"},
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            path: "name",
            label: "Název",
            feedback: _unref(errors).name,
            "validation-status": _unref(errors).name ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.name) = $event)),
                    size: "large",
                    placeholder: "Název",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(NFormItem), {
                path: "client",
                label: "Klient",
                feedback: _unref(errors).client,
                "validation-status": _unref(errors).client ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NSelect), {
                        value: formModel.value.client,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.client) = $event)),
                        size: "large",
                        filterable: "",
                        tag: "",
                        disabled: pending.value,
                        placeholder: "Klient",
                        options: _unref(clientsOptions),
                        onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "disabled", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(NFormItem), {
                path: "campaign",
                label: "Kampaň",
                feedback: _unref(errors).campaign,
                "validation-status": _unref(errors).campaign ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NSelect), {
                        value: formModel.value.campaign,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.campaign) = $event)),
                        size: "large",
                        filterable: "",
                        tag: "",
                        disabled: pending.value,
                        placeholder: "Kampaň",
                        options: _unref(campaignsOptions),
                        onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "disabled", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(NFormItem), {
                path: "type_id",
                label: "Typ článku",
                feedback: _unref(errors).type_id,
                "validation-status": _unref(errors).type_id ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NSelect), {
                        value: formModel.value.type_id,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formModel.value.type_id) = $event)),
                        size: "large",
                        filterable: "",
                        disabled: pending.value,
                        placeholder: "Typ článku",
                        options: _unref(measurementTypeOptions),
                        onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "disabled", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(NFormItem), {
                path: "type_id",
                label: "Web",
                feedback: _unref(errors).web_id,
                "validation-status": _unref(errors).web_id ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NSelect), {
                        value: formModel.value.web_id,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formModel.value.web_id) = $event)),
                        size: "large",
                        filterable: "",
                        disabled: pending.value,
                        placeholder: "Web",
                        options: _unref(measurementWebOptions),
                        onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "disabled", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(NFormItem), {
                ref_key: "startDateRef",
                ref: startDateRef,
                path: "start_date",
                label: "Začátek měření",
                feedback: _unref(errors).start_date,
                "validation-status": _unref(errors).start_date ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDatePicker), {
                        value: formModel.value.start_date,
                        "onUpdate:value": [
                          _cache[9] || (_cache[9] = ($event: any) => ((formModel.value.start_date) = $event)),
                          handleStartDateInput
                        ],
                        size: "large",
                        actions: ['now'],
                        "input-readonly": "",
                        type: "date",
                        style: {"width":"100%"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(NFormItem), {
                ref_key: "endDateRef",
                ref: endDateRef,
                path: "end_date",
                actions: ['now'],
                label: "Konec měření",
                feedback: _unref(errors).end_date,
                "validation-status": _unref(errors).end_date ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDatePicker), {
                        value: formModel.value.end_date,
                        "onUpdate:value": [
                          _cache[10] || (_cache[10] = ($event: any) => ((formModel.value.end_date) = $event)),
                          handleEndDateInput
                        ],
                        size: "large",
                        "input-readonly": "",
                        type: "date",
                        actions: ['now'],
                        style: {"width":"100%"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(NFormItem), {
                path: "sales_person_id",
                label: "Obchodník",
                feedback: _unref(errors).sales_person_id,
                "validation-status": _unref(errors).sales_person_id ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NSelect), {
                        value: formModel.value.sales_person_id,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((formModel.value.sales_person_id) = $event)),
                        size: "large",
                        "render-label": renderLabel,
                        filterable: "",
                        disabled: pending.value,
                        placeholder: "Obchodník",
                        options: _unref(salesPersonsOptions),
                        onKeydown: _cache[12] || (_cache[12] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "disabled", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_unref(NFormItem), {
                path: "impressions_target",
                label: "Cíl impresí",
                feedback: _unref(errors).impressions_target,
                "validation-status": _unref(errors).impressions_target ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        value: formModel.value.impressions_target,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((formModel.value.impressions_target) = $event)),
                        size: "large",
                        step: targetStep.value,
                        min: 0,
                        placeholder: "Cíl impresí",
                        disabled: pending.value,
                        style: {"width":"100%"},
                        onKeydown: _cache[14] || (_cache[14] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "step", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(NFormItem), {
                path: "clicks_target",
                label: "Cíl prokliků",
                feedback: _unref(errors).clicks_target,
                "validation-status": _unref(errors).clicks_target ? 'error' : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        value: formModel.value.clicks_target,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((formModel.value.clicks_target) = $event)),
                        size: "large",
                        step: targetStep.value,
                        min: 0,
                        placeholder: "Cíl prokliků",
                        disabled: pending.value,
                        style: {"width":"100%"},
                        onKeydown: _cache[16] || (_cache[16] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value", "step", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["feedback", "validation-status"])
            ])
          ]),
          _createVNode(_unref(NFormItem), {
            path: "url",
            label: "URL článku",
            feedback: _unref(errors).url,
            "validation-status": _unref(errors).url ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.url,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((formModel.value.url) = $event)),
                    size: "large",
                    placeholder: "URL článku",
                    disabled: pending.value,
                    onKeydown: _cache[18] || (_cache[18] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createVNode(_unref(NFormItem), {
            path: "target_url",
            label: "Proklikové URL",
            feedback: _unref(errors).target_url,
            "validation-status": _unref(errors).target_url ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NDynamicInput), {
                value: formModel.value.target_url,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((formModel.value.target_url) = $event)),
                size: "large",
                placeholder: "Prokliková URL",
                onKeydown: _cache[20] || (_cache[20] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          (_unref(errors).message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_unref(NAlert), { type: "error" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(errors).message), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(BaseFlex, {
            justify: "center",
            align: "center",
            "col-gap": "5px",
            "class-name": "py-m",
            "row-gap": "15px",
            "mobile-col": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                "attr-type": "submit",
                disabled: 
					!!(
						pending.value ||
						formModel.value.name === null ||
						formModel.value.name === '' ||
						formModel.value.start_date === null ||
						formModel.value.end_date === null ||
						formModel.value.type_id === null ||
						formModel.value.type_id === '' ||
						formModel.value.web_id === null ||
						formModel.value.web_id === '' ||
						formModel.value.client === null ||
						formModel.value.client === '' ||
						formModel.value.campaign === null ||
						formModel.value.campaign === '' ||
						formModel.value.sales_person_id === null ||
						formModel.value.sales_person_id === ''
					)
				,
                loading: pending.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.isEdit ? 'Uložit změny' : 'Vytvořit nový záznam'), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]),
              _createVNode(_unref(NButton), {
                type: "default",
                size: "large",
                "attr-type": "button",
                onClick: _cache[21] || (_cache[21] = 
					() => {
						__props.isEdit ? stornoEdit() : listRedirect();
					}
				)
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]))
}
}

})